<script lang="ts" setup>
const props = defineProps<{ image?: string, video?: string, mobileVideo?: string, theme: Theme }>()
const { siteName = '' } = useRuntimeConfig().public
const isDesktop = useMediaQuery('(min-width: 768px)', { ssrWidth: 1024 })
const videoSource = computed(() => isDesktop.value ? props.video : props.mobileVideo)
</script>

<template>
  <div class="w-full relative flex justify-center">
    <div class="max-w-screen-2xl mx-auto relative z-10 flex items-center w-full flex-col px-3">
      <slot />
    </div>
    <div class="absolute inset-0 w-full h-full z-0 rounded-b-4xl overflow-clip">
      <slot name="background" />
      <video
        v-if="videoSource"
        :key="videoSource"
        autoplay
        muted
        loop
        playsinline
        preload="metadata"
        class="w-full h-full object-cover"
        :aria-label="siteName"
      >
        <source
          :src="videoSource"
          type="video/mp4"
        >
        Your browser does not support the video tag.
      </video>
      <NuxtPicture
        v-else-if="image"
        :src="image"
        :img-attrs="{ class: 'w-full h-full object-cover' }"
        :alt="siteName"
      />
    </div>
  </div>
</template>
